// extracted by mini-css-extract-plugin
module.exports = {"allCheckboxes":"Checkbox_allCheckboxes__3gL-4","display":"Checkbox_display__3ywET","checkbox":"Checkbox_checkbox__1wgp9"};